import "@mui/lab/themeAugmentation";

import { createAppTheme } from "../design-system/theme";
import variants from "./variants";
import components from "./components";

// LWI-1563 — IQ's theme is the shared design-system theme plus the
// Profile-page presets (variants.js) and IQ-specific component overrides
// (components.js). Signature unchanged: createTheme(THEMES.X).
const createTheme = (name) => {
  let themeConfig = variants.find((variant) => variant.name === name);

  if (!themeConfig) {
    console.warn(new Error(`The theme ${name} is not valid`));
    themeConfig = variants[0];
  }

  return createAppTheme({
    mode: themeConfig.mode,
    name: themeConfig.name,
    palette: themeConfig.palette,
    header: themeConfig.header,
    footer: themeConfig.footer,
    sidebar: themeConfig.sidebar,
    components,
  });
};

export default createTheme;
